// extracted by mini-css-extract-plugin
export var columnList = "_eh-0";